import DisplayItems from "../../methods/displayItems/DisplayItems";
import ImageCart from "../../views/carts/imageCart/ImageCart";
import { works } from "./data/data";
import "./style.css";

export default function WorkPage(params) {
  return (
    <div className="workPage ">
      <DisplayItems grid items={works} View={ImageCart} />
    </div>
  );
}
